import { LandingPerks as LandingPerksType } from 'app/blocks/landing/landing-perks'
import SubscriptionPanel from 'app/components/primitive/SubscriptionPanel'
import Section from 'app/components/structure/Section'
import useQuery from 'app/hooks/use-query'
import { createPerksQuery, mapPerks } from 'app/queries/perks/perks'
import { PlanLevel, Tier } from 'app/queries/tiers/member-tiers'
import { useStores } from 'app/store'
import React, { useMemo } from 'react'

const perksQuery = createPerksQuery()

interface LandingPerksBlockProps {
  block: LandingPerksType
}

export const LandingPerksBlock: React.FC<LandingPerksBlockProps> = ({
  block,
}) => {
  const { userStore } = useStores()
  const { data: perks } = useQuery(perksQuery, {}, mapPerks)

  const memberTiers = useMemo((): (Tier & { description: string })[] => {
    if (!block.tiers) return []

    return block.tiers.map((blockTier) => ({
      id: blockTier.memberTier.id,
      name: blockTier.displayName || blockTier.memberTier.name,
      planLevel: blockTier.memberTier.planLevel as PlanLevel,
      description: blockTier.description || '',
      memberfulPlans: blockTier.memberTier.memberfulPlans.map((mp) => {
        const plan = mp.memberfulPlan

        let priceString: string
        if (typeof plan.price === 'string') {
          priceString = plan.price.replace('$', '').trim()
        } else if (typeof plan.price === 'number') {
          priceString = plan.price.toFixed(2)
        } else {
          priceString = '0.00'
        }

        return {
          type: plan.type,
          externalId: plan.externalId,
          price: priceString,
          savings: plan.savings?.toString() || '',
          ctaLabel: plan.type,
          smallPrint: plan.smallPrint || '',
        }
      }),
    }))
  }, [block.tiers])

  if (!userStore?.canMemberfulLink) return null

  return (
    <Section paddedX>
      <SubscriptionPanel
        memberTiers={memberTiers}
        perks={perks}
        subtitle={block.subtitle}
        title={block.title}
      />
    </Section>
  )
}
